module.exports = __webpack_public_path__ + "static/media/LanternCityMarketEXTA0001_design_clean_v001.97e8437a.png";